import {ProductClipPropertiesType} from "../types";
import {formatDuration} from "../utils";

export const ProdInfo = ({imageCount, duration}: ProductClipPropertiesType) => {
    return (
        <div className="prodinfo">
            <div className="prodinfo__item">
                <svg role="img" className="prodinfo__ico">
                    <use href="./img/sprite.svg#pc_info_pics"></use>
                </svg>
                {imageCount} pic
            </div>
            <div className="prodinfo__item">
                <svg role="img" className="prodinfo__ico">
                    <use href="./img/sprite.svg#pc_info_time"></use>
                </svg>
                {formatDuration(String(duration))}
            </div>
        </div>
    );
}

export default ProdInfo;